import { render, staticRenderFns } from "./AvailablePlaceholder.vue?vue&type=template&id=3fabd052&"
import script from "./AvailablePlaceholder.vue?vue&type=script&lang=js&"
export * from "./AvailablePlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports